import {Grid, Typography} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Panel from 'components/Panel';
import FormikTransferListSearchable, {
   FormikTransferListSearchableProps,
} from 'components/inputs/FormikTransferListSearchable';
import {VALUE_NAME} from 'components/dialogs/TransferListDialog';

import * as yup from 'common/yup';
import i18n from 'i18n';
import {RoleNames} from 'types/diplomat/settings/RoleNames';
import {LDAPmapPanel} from 'common/panels/LDAPmapPanel';
import api from 'api';

export const RoleMembersSchema = yup.object({
   [VALUE_NAME]: yup
      .array()
      .of(yup.string())
      .min(1, i18n.t('Should be at least one Administrator')),
   [RoleNames.includeLdapUsers]: yup.boolean(),
   [RoleNames.ldapGroupFilter]: yup.string(),
});
export type IRoleMembersSchema = yup.InferType<typeof RoleMembersSchema>;

type Props = {
   id: string;
   onClose: () => void;
   // refreshLdap: () => void;
   isLdapConfigured: boolean;

   optionsLabel: FormikTransferListSearchableProps['optionsLabel'];
   valuesLabel: FormikTransferListSearchableProps['valuesLabel'];
   options: FormikTransferListSearchableProps['options'];
   adminUsers?: FormikTransferListSearchableProps['options'];
};
export const RoleMembersForm = ({
   onClose,

   optionsLabel,
   valuesLabel,
   options,
}: Props) => {
   const {t} = useTranslation();

   return (
      <>
         {/* {fields.length ? ( */}
         <>
            <Panel name={t('Admin User Role Membership')}>
               <Grid container spacing={2} justifyContent="space-between">
                  <Grid item sm={12}>
                     <Typography>
                        {t(
                           'Specify the Diplomat MFT Admin Users that belong to this role.\n An Admin User may belong to more than one role.'
                        )}
                     </Typography>
                  </Grid>
                  <Grid item sm={12}>
                     <FormikTransferListSearchable
                        name={VALUE_NAME}
                        optionsLabel={optionsLabel}
                        valuesLabel={valuesLabel}
                        options={options}
                        // freeze={['ALL USERS']}
                        // inverse
                        // disabled
                     />
                  </Grid>
               </Grid>
            </Panel>

            <LDAPmapPanel
               title={t('LDAP Group Role Assignment')}
               content={t(
                  "Specify the CN of an LDAP group, and that group's membership will be automatically added to this role."
               )}
               checkboxLabel={t('Map LDAP groups to this role')}
               filterApi={api.testldapAdminRoles}
            />

            <FormFooterButtons submitLabel={t('Save')} cancel={onClose} />
         </>
      </>
   );
};
